<template>
  <div style="width: 100%">
    <!-- <v-breadcrumbs :items="ufs" divider=" - ">
      <v-breadcrumbs-item
        style="cursor: pointer; text-decoration: underline"
        slot="item"
        slot-scope="{ item }"
        @click="filterByCity(item.text)"
      >
        {{ item.text }}
      </v-breadcrumbs-item>
    </v-breadcrumbs> -->
    <!-- <div class="mx-15 px-15">
      <v-alert class="mx-15" v-if="!closures.length" dense text type="success">
        Não existem fechamentos cadastrados
      </v-alert>
    </div> -->
    <v-row no-gutters class="mt-5">
      <v-col
        v-for="(closure, index) in closures"
        :key="index"
        :class="[$store.state.mobileMode ? '' : 'px-15', 'mt-5 mb-10']"
        cols="12"
        sm="6"
      >
        <h3 class="h3 text-left mb-3">{{ closure.title }}</h3>
        <v-img width="auto" :src="closure.image"></v-img>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  mounted() {
    this.getClosures();
  },
  methods: {
    getClosures() {
      var obj = {
        url: "/api/cfc/listCfc",
        query: {
          type: "closure",
          filter: "",
        },
        method: "post",
      };
      //console.log("site close");
      this.$store.dispatch("request/doRequest", obj).then((response) => {
        // console.log(response);
        this.closures = [...response.data.data];
      });
    },
  },
  data() {
    return {
      closures: [],
      ufs: [
        {
          text: "São Paulo",
          disabled: false,
          //   href: "breadcrumbs_dashboard",
        },
        {
          text: "Distrito Federal",
          disabled: false,
          //   href: "breadcrumbs_dashboard",
        },
        {
          text: "Paraíba",
          disabled: false,
          //   href: "breadcrumbs_dashboard",
        },
        {
          text: "Rio de Janeiro",
          disabled: false,
          //   href: "breadcrumbs_dashboard",
        },
      ],
    };
  },
};
</script>

<style>
</style>